"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewSceneArray = void 0;
const View_enums_1 = require("./View.enums");
exports.ViewSceneArray = [View_enums_1.ViewScene.Day, View_enums_1.ViewScene.Night];
//# sourceMappingURL=View.const.js.map